import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reverse";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ActionButtons from "./credit-report-table-action-buttons.vue";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import CreditReportTableLoader from "./loaders/credit-report-table-loader.vue";
import { isEmpty, values } from "lodash";
import { mapGetters } from "vuex";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CreditReportTable",
  components: {
    ActionButtons,
    NotificationPopover,
    CreditReportTableLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    creditReports: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columnsTable: ["name", "dateObtained", "creditScore", "authDate", "authorizationMethod", "status", "submit", "id", "actions"]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    creditReportsData() {
      var _context;
      return _reverseInstanceProperty(_context = values(this.creditReports.byId)).call(_context);
    },
    options() {
      return {
        filterable: false,
        sortable: ["name", "dateObtained", "creditScore", "authDate", "authorizationMethod", "status"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        showChildRowToggler: false,
        perPage: 999999,
        hiddenColumns: ["id"],
        columnsDisplay: {
          dateObtained: "min_desktop"
        },
        headings: {
          name: this.$t("account.name"),
          dateObtained: this.$t("direct-to-lender.creditBureau.dateObtained"),
          creditScore: this.$t("direct-to-lender.creditBureau.creditScore"),
          authDate: this.$t("direct-to-lender.creditBureau.authObtainedDate"),
          authorizationMethod: this.$t("direct-to-lender.creditBureau.authorizationMethod"),
          status: this.$t("global.words.status"),
          submit: this.$t("direct-to-lender.creditBureau.submitToLender"),
          actions: this.$t("global.words.actions")
        },
        columnsClasses: {
          actions: "hidden-heading"
        },
        texts: {
          count: ""
        },
        tabbable: false,
        skin: "table table-hover"
      };
    },
    creditReportsForLenderByApplicant() {
      var _this$creditReportsDa;
      return (_this$creditReportsDa = this.creditReportsData) == null ? void 0 : _reduceInstanceProperty(_this$creditReportsDa).call(_this$creditReportsDa, (reportsByApplicant, current) => {
        if (current.submitToLender) {
          var _current$firstName, _current$lastName;
          const applicantName = `${((_current$firstName = current.firstName) == null ? void 0 : _current$firstName.toLowerCase()) || ""}-${((_current$lastName = current.lastName) == null ? void 0 : _current$lastName.toLowerCase()) || ""}`;
          reportsByApplicant[applicantName] = current;
        }
        return reportsByApplicant;
      }, {});
    }
  }),
  methods: {
    changeSubmitToLender({
      id,
      submitToLender
    }) {
      this.$emit("change-submit-to-lender", {
        id,
        submitToLender
      });
    },
    handlePreview({
      row,
      index
    }) {
      this.$emit("preview-credit-report", {
        documentId: row.creditReportSummary,
        pdfDocumentId: row.creditReportPdf,
        index
      });
    },
    handleCopyLiabilities({
      row,
      index
    }) {
      this.$emit("copy-liabilities", {
        currentId: row.id,
        index
      });
    },
    stopLoader({
      type,
      status,
      index
    }) {
      if (type === "copy") this.$refs[`actionButtons-${index}`].stopCopyLoader(status);else this.$refs[`actionButtons-${index}`].stopPreviewLoader(status);
    },
    getPopoverTitle(errors) {
      return `${this.$tc("global.messages.failReason", errors == null ? void 0 : errors.length)}`;
    },
    disableSubmitToLenderCheck(row) {
      var _row$firstName, _row$lastName, _this$creditReportsFo;
      if (row.submitToLender) return false;
      const applicantName = `${((_row$firstName = row.firstName) == null ? void 0 : _row$firstName.toLowerCase()) || ""}-${((_row$lastName = row.lastName) == null ? void 0 : _row$lastName.toLowerCase()) || ""}`;
      return !isEmpty((_this$creditReportsFo = this.creditReportsForLenderByApplicant) == null ? void 0 : _this$creditReportsFo[applicantName]);
    }
  }
});